import { Button } from "@mui/material";
import { InputBox, Icon, Dropdown } from "@components/index";
import { userRoles, userStatusOptions } from "@constants/userConstants";
import "./index.scss";

const UserFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const handleInputChange = (field, value) => {
    onFilterChange({ ...filters, [field]: value });
  };

  const handleClear = () => {
    onClearFilters();
  };

  return (
    <div className="user-filters">
      <div className="filters-row">
        <InputBox
          label="Search Users"
          size="small"
          value={filters.searchValue || ""}
          onChange={(e) => handleInputChange("searchValue", e.target.value)}
          className="filter-input filter-input--search"
          placeholder="Search by name, email, or mobile number"
        />

        <Dropdown
          value={filters.role || ""}
          onChange={(value) => handleInputChange("role", value)}
          options={userRoles}
          placeholder="Role Type"
          size="small"
          className="filter-select"
        />

        <Dropdown
          value={filters.status || ""}
          onChange={(value) => handleInputChange("status", value)}
          options={userStatusOptions}
          placeholder="Status"
          size="small"
          className="filter-select"
        />

        <Button
          variant="outlined"
          onClick={handleClear}
          className="clear-filters-btn"
          startIcon={<Icon iconName="delete" width={16} height={16} />}
        >
          Clear Filters
        </Button>
      </div>
    </div>
  );
};

export default UserFilters;
